module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/images/tank-available-CN.6d74d2ef.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/images/tank-available-CN.png
// module id = 3041
// module chunks = 11